import ButtonPair from "../reusable/ButtonPair";

const HeroText = () => {
  const heroPoints = [
    "Rigorous interviews and recruitment processes to hire qualified assistants",
    "A robust curriculum to equip assistants with required knowledge",
    "Match clients with adept assistants",
  ];
  return (
    <div data-aos="flip-left" className="px-3 lg:px-0">
      <div className="mb-8">
        <h1
          id="hero_text"
          className="sys_primary font-black text-3xl lg:text-5xl mb-4"
        >
          We Recruit,{" "}
          <span className="sys_black">
            Train and <br /> place{" "}
          </span>
          assistants
        </h1>
        <div className="text-normal lg:text-xl lg:leading-8 sys_gray">
          {heroPoints.map((point, i) => {
            return (
              <div key={i} className="flex flex-col items-center lg:flex-row my-2">
                <img className="w-4" src="/assets/icons/tick_2.svg" alt="tick" />
                <p className="ml-2">{point}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex justify-center lg:block">
        <ButtonPair />
      </div>
    </div>
  );
};

export default HeroText;
